export class FileUploadConfig {
  constructor() {
    this.multiple = true;
    this.emailOnly = false;
    this.excludeEmails = false;
    this.scanRequired = false;
    this.files = [];
    this.isInvoice = false;
  }
  excludeEmails: boolean;
  multiple: boolean;
  emailOnly: boolean; //The 'emailOnly' supports '.msg' type files only, and only used for email scanning.
  scanRequired: boolean;
  excelFileOnly: boolean;
  isInvoice: boolean;

  files: Array<{
    name: string;
    url: string;
    comment: string;
    existing?: boolean;
    isScanForAsset?: boolean;
  }>;

  private _title = '';
  set title(value: string) {
    if (!value) return;
    this._title = value;
  }
  get title(): string {
    if (this.emailOnly) return 'Drag & drop the email to upload';
    else if (!this._title) return 'Drop Images and Attachments Here';
    return this._title;
  }

  private _icon = 'icon-Image mb-3';
  set icon(value: string) {
    if (!value) return;
    this._icon = value;
  }
  get icon(): string {
    if (this.emailOnly) return 'icon-Mail mb-3';
    else if (!this._icon) return 'icon-Image mb-3';
    return this._icon;
  }

  private _supportedExtensions: string;
  set supportedExtensions(value: string) {
    if (!value) return;
    this._supportedExtensions = value;
  }

  get supportedExtensions(): string {
    if (this._supportedExtensions) return this._supportedExtensions;

    // defaults
    if (this.emailOnly) return '.msg , .eml';
    if (this.excludeEmails && !this.isInvoice)
      return '.jpg, .jpeg, .png, .gif, .tiff, .mp4, .csv, .pdf, .mov';
    if (this.isInvoice)
      return '.jpg, .jpeg, .png, .pdf';
    return '.jpg, .jpeg, .png, .gif, .tiff, .mp4, .csv, .pdf, .eml, .msg, .mov';
  }
  displaySupportedExtensions: boolean = false;
}
